/**
 * @returns {null|number}
 */
var getScrollWidth = function getScrollWidth() {
  if (typeof document === 'undefined') {
    return null;
  }

  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return windowWidth - documentWidth;
};
/**
 * @param {boolean} on - Turn the background scroll tether on or off.
 */


export var backgroundScrollTether = function backgroundScrollTether(on) {
  // Injects a style tag that styles the body
  // since body lives outside of the React app root.

  /* istanbul ignore next */
  if (typeof document === 'undefined') {
    return null;
  }

  var id = 'backgroundScrollTether';

  var get = function get() {
    return document.querySelector("#".concat(id));
  };

  if (on) {
    if (!get()) {
      var style = document.createElement('style');
      style.id = id;
      style.innerText = "body { padding-right: ".concat(getScrollWidth(), "px; overflow-y: hidden; }");
      document.body.appendChild(style);
    }
  } else {
    var _style = get();

    if (_style && _style.parentNode) _style.parentNode.removeChild(_style); // IE11
  }
};
export default backgroundScrollTether;